import { AVILABLE_PAYMENT_METHOD_COUNT, AVILAIBLE_PAYMENT_METHODS_WITHOUT_OTHER } from '@/constants/payment';
import { PaymentMethodEnum } from '@/types/common';
import type { AvailablePaymentMethod, CheckoutConfigurations, PaymentMethod } from '@/types/checkout';

export const getTopPaymentMethods = (paymentMethods: PaymentMethod[]) => {
  return [...paymentMethods.slice(0, AVILABLE_PAYMENT_METHOD_COUNT)];
};

export const getOtherPaymentMethods = (paymentMethods: AvailablePaymentMethod[]): AvailablePaymentMethod[] => {
  return paymentMethods
    .slice(AVILABLE_PAYMENT_METHOD_COUNT, paymentMethods.length)
    .filter((paymentMethod) => paymentMethod.paymentMethodName !== PaymentMethodEnum.OTHER && !paymentMethod.isExpress);
};

// Synthetic "Other" payment method for UI grouping
const OTHER_PAYMENT_METHOD: AvailablePaymentMethod = {
  id: PaymentMethodEnum.OTHER,
  paymentMethodName: PaymentMethodEnum.OTHER,
  paymentMethodDisplayName: PaymentMethodEnum.OTHER,
  pspPaymentMethodName: null,
  provider: '',
  submidName: '',
  isExpress: false,
};

const isExpressPaymentMethod = (paymentMethodName: string, checkoutConfig?: CheckoutConfigurations): boolean => {
  switch (paymentMethodName) {
    case PaymentMethodEnum.APPLE_PAY:
      return true;
    case PaymentMethodEnum.PAYPAL:
      return !checkoutConfig?.shouldShowPayPalAsApm;
    case PaymentMethodEnum.GOOGLE_PAY:
      return !checkoutConfig?.shouldShowGooglePayAsApm;
    case PaymentMethodEnum.LINK:
      return !checkoutConfig?.featureFlags?.checkout_display_link_express_as_apm_box;
    default:
      return false;
  }
};

export const organizePaymentMethods = (
  paymentMethods: PaymentMethod[],
  checkoutConfig?: CheckoutConfigurations
): AvailablePaymentMethod[] => {
  const extendedPaymentMethods = paymentMethods
    .filter((pm) => pm.paymentMethodName !== PaymentMethodEnum.OTHER)
    .map((pm) => ({
      ...pm,
      isExpress: isExpressPaymentMethod(pm.paymentMethodName, checkoutConfig),
    }));

  const shouldAddOtherMethod =
    extendedPaymentMethods.filter((pm) => !pm.isExpress).length > AVILABLE_PAYMENT_METHOD_COUNT;
  if (!shouldAddOtherMethod) {
    return extendedPaymentMethods;
  }
  const extendedPaymentMethodsWithoutExpress = extendedPaymentMethods.filter((pm) => !pm.isExpress);
  const extendedPaymentMethodsWithExpress = extendedPaymentMethods.filter((pm) => pm.isExpress);
  const topMethods = extendedPaymentMethodsWithoutExpress.slice(0, AVILAIBLE_PAYMENT_METHODS_WITHOUT_OTHER);
  const remainingMethods = extendedPaymentMethodsWithoutExpress.slice(AVILAIBLE_PAYMENT_METHODS_WITHOUT_OTHER);

  return [...topMethods, OTHER_PAYMENT_METHOD, ...remainingMethods, ...extendedPaymentMethodsWithExpress];
};

export const getPaymentMethodLogoUrl = (paymentMethodName: string): string => {
  return `https://media.appcharge.com/defaults/apm_logos/v3/logo/${paymentMethodName}.svg`;
};

export const getPaymentMethodBoxUrl = (paymentMethodName: string): string => {
  return `https://media.appcharge.com/defaults/apm_logos/v3/box/${paymentMethodName}.svg`;
};
